'use strict';

const BuildMoment = require('moment');
const Constants = require('../constants');
const PickerPresenter = require('./picker');

class DatePickerPresenter extends PickerPresenter {
  constructor() {
    super(...arguments);
    this.setModule('glive_booking_redesign');
  }

  toHash() {
    const hash = super.toHash(...arguments);
    hash.selectedDate = this.selected() && this.getSelectedDate();
    return hash;
  }

  getSelectedDate() {
    const dateString = this.selected().toString();
    const momentDate = BuildMoment(dateString);
    return momentDate.isValid() ? momentDate.format(Constants.date.titleFormat) : dateString;
  }
}

module.exports = DatePickerPresenter;
